import "./legal-notice.css";
import { Container, Divider, Grid, Header, List } from "semantic-ui-react";

const LegalNotice = () => {
    return (
        <Container className="legal-notice">
            <Grid doubling columns={2}>
                <Grid.Column width={6}>
                    <Header
                        as="h3"
                        content="Legal Notice"
                        className="legal-notice-h3"
                    />
                </Grid.Column>
                <Grid.Column width={10}>
                    <p className="legal-notice-description">
                        This page provides the core company and website details for the visgroup.co.uk website.
                    </p>

                    <div className="legal-notice-section">
                        <Header
                            as="h4"
                            content="Company Details"
                            className="legal-notice-h4"
                        />
                        <List relaxed className="legal-notice-list">
                            <List.Item>
                                <strong>Company name:</strong> VIS Ventilation Industrial Systems Ltd
                            </List.Item>
                            <List.Item>
                                <strong>Website branding used on this site:</strong> VIS GROUP
                            </List.Item>
                            <List.Item>
                                <strong>Website:</strong>{" "}
                                <a href="https://visgroup.co.uk" target="_blank" rel="noreferrer">
                                    visgroup.co.uk
                                </a>
                            </List.Item>
                            <List.Item>
                                <strong>Postal address:</strong> 41 Rothersthorpe Avenue, Northampton NN4 8JH, United Kingdom
                            </List.Item>
                            <List.Item>
                                <strong>Telephone:</strong>{" "}
                                <a href="tel:+441604217969">+44 1604 217969</a>
                            </List.Item>
                            <List.Item>
                                <strong>Email:</strong>{" "}
                                <a href="mailto:info@visgroup.co.uk">info@visgroup.co.uk</a>
                            </List.Item>
                        </List>
                    </div>

                    <Divider />

                    <div className="legal-notice-section">
                        <Header
                            as="h4"
                            content="Contact"
                            className="legal-notice-h4"
                        />
                        <p className="legal-notice-text">
                            For legal, company, or website enquiries, use the telephone number, email address, or
                            postal address listed on this page.
                        </p>
                    </div>
                </Grid.Column>
            </Grid>
        </Container>
    );
};

export default LegalNotice;
